import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../utils/api';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const [activeTenant, setActiveTenant] = useState(() => {
    try { return JSON.parse(localStorage.getItem('activeTenant')) || null; } catch { return null; }
  });
  const [tenants, setTenants]     = useState([]);
  const [tenantRole, setTenantRole] = useState(null);

  const switchTenant = useCallback((tenant, role) => {
    setActiveTenant(tenant);
    setTenantRole(role);
    if (tenant) {
      localStorage.setItem('activeTenant', JSON.stringify(tenant));
    } else {
      localStorage.removeItem('activeTenant');
    }
  }, []);

  const loadMyTenants = useCallback(async () => {
    try {
      const res = await api.get('/my-tenants');
      setTenants(res.data);
      // Auto-select if only one tenant
      if (res.data.length === 1 && !activeTenant) {
        switchTenant(res.data[0], res.data[0].my_role);
      }
      return res.data;
    } catch { return []; }
  }, [activeTenant, switchTenant]);

  const clearTenant = useCallback(() => {
    setActiveTenant(null);
    setTenantRole(null);
    localStorage.removeItem('activeTenant');
  }, []);

  return (
    <TenantContext.Provider value={{ activeTenant, tenants, tenantRole, switchTenant, loadMyTenants, clearTenant, setTenants }}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
